/**
 * Animate header
 */
const tlHeader = gsap.timeline({
  scrollTrigger: {
    trigger: ".page-header",
    start: "top top",
    end: "bottom top",
    scrub: 2
  }
});

gsap.utils.toArray(".parallax").forEach(layer => {
  const depth = layer.dataset.depth;
  const movement = -(300 * depth)
  tlHeader.to(layer, {y: movement, ease: "none"}, 0)
});
